import { fromUntagged } from './fromUntagged'
import { getResource } from './getResource'
import { is } from './is'

export const Entity = {
  fromUntagged,
  getResource,
  is,
}
